export const setUserDetails = (details) => ({
    type: 'SET_USER_DETAILS',
    details
});